import { Badge, Tooltip, TooltipContent, TooltipTrigger } from "@fox1ck-org/ui";

interface RoleBadgeProps {
  name: string;
  description?: string;
}

export function RoleBadge({ name, description }: RoleBadgeProps) {
  const badge = (
    <Badge variant="neutral" className="font-mono text-xs">
      {name}
    </Badge>
  );

  if (!description) return badge;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent>{description}</TooltipContent>
    </Tooltip>
  );
}
